module.exports = __webpack_public_path__ + "static/img/login-logo2.bfa88f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/login-logo2.png
// module id = QqC4
// module chunks = 1